import { Box, Button, Menu, MenuItem } from '@atgfr8/atg-ui-tailwind';
import { MenuDownIcon, OpenInNewIcon } from '@atgfr8/icons';
import { labelSizeOptions, type LabelSizeValue } from '@common/commonLists';
import { carrierUrls } from '@constants/urls';
import { createSignal } from 'solid-js';

function ShippingLabelButton(props: { load: { id: number } }) {
  const [anchorEl, setAnchorEl] = createSignal<HTMLButtonElement | undefined>(
    undefined,
  );

  const handleOpen = (e: MouseEvent) => {
    setAnchorEl(e.currentTarget as HTMLButtonElement);
  };
  const handleClose = () => setAnchorEl(undefined);

  const openFor = (size: LabelSizeValue) => {
    const url = carrierUrls.shippingLabel(props.load.id, size);
    window.open(url, '_blank', 'noopener,noreferrer');
    handleClose();
  };

  return (
    <Box>
      <Button
        variant="contained"
        size="sm"
        dataTestId="shipping-label-button"
        class="text-armstrong-sm! bg-white! border-[#123B50]! border! font rounded-sm! text-[#123B50]!"
        sx={{
          border: '1px solid #123B50',
          'text-transform': 'none',
        }}
        endIcon={<MenuDownIcon size={20} />}
        aria-haspopup="menu"
        onMouseDown={handleOpen}
        ref={setAnchorEl}
      >
        SHIPPING LABEL
      </Button>

      <Menu anchorEl={anchorEl}>
        {labelSizeOptions.map((opt) => (
          <MenuItem onClick={() => openFor(opt.value)}>
            <span class="inline-flex items-center justify-center h-[22px] w-[36px] align-middle">
              <OpenInNewIcon size={20} />
            </span>{' '}
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default ShippingLabelButton;
